import { ReactComponent as DownloadSvg } from "@/src/assets/icons/icon-download-black.svg";
import { ReactComponent as InfoSvg } from "@/src/assets/icons/icon-info-gray6.svg";
import TabItem from "@/src/components/molecule/TabItem";
import Typo from "@/src/components/atom/Typo";
import colorSet, { ColorType } from "@/src/styles/color";
import typo from "@/src/styles/typography";
import { css, styled } from "styled-components";

export const InnerContent = styled.div`
  border: 1px solid ${colorSet.gray9};
  border-radius: 8px;
`;

export const FlexBox = styled.div`
  display: flex;
`;

export const FixedWidthFlexItem = styled.div`
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: relative;

  &:first-of-type {
    border-right: 1px solid ${colorSet.gray9};
  }

  &:last-of-type {
    border-left: 1px solid ${colorSet.gray9};
  }
`;

export const RestWidthFlexItem = styled.div`
  flex: 1;
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 60px;
`;

export const Tabs = styled.div`
  display: flex;
  border-radius: 8px;
`;

export const StyledTabItem = styled(TabItem)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 13px;
  border: none;
  cursor: pointer;
  background: none;

  &[data-selected="true"] {
    padding: 10px 13px 8px 13px;
    border-bottom: 2px solid ${colorSet.gray2};
  }
`;

export const FlexAlignCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &.padding-12 {
    padding: 12px;
  }
`;

export const ContainerItem = styled(FlexAlignCenter)`
  cursor: pointer;

  .ellipsis-label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    background: ${colorSet.gray10};
  }

  &[data-selected="true"] {
    background: ${colorSet.systemBlue6};
  }
`;

export const AllContainerCell = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${colorSet.gray11};
  border-top: 1px solid ${colorSet.gray9};
  border-bottom: 1px solid ${colorSet.gray9};
`;

export const ContainerList = styled.div`
  display: flex;
  flex-direction: column;
  height: 596px;
  overflow: auto;
  position: relative;
`;

export const DownloadButton = styled.button`
  position: absolute;
  all: unset;
  box-sizing: border-box;
  padding: 12px;
  background: ${colorSet.indigo};
  color: ${colorSet.white};
  border-radius: 0 0 0 8px;
  cursor: pointer;
  ${typo.b8m};
  display: flex;
  gap: 8px;
  align-items: center;

  &:disabled {
    background: ${colorSet.gray10};
    cursor: not-allowed;
  }
`;

export const MiddleTitleSection = styled.div`
  width: 100%;
  height: 61px;
  padding: 16px 16px 10px 16px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  background: ${colorSet.gray11};
  border-bottom: 1px solid ${colorSet.gray9};

  .ellipsis-header {
    max-width: 617px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MiddleRestSection = styled.div`
  flex: 1;
  height: 689px;
  overflow: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.gap-24 {
    gap: 24px;
  }
`;

export const ContainerItemArticle = styled.article<{
  tabType: "container" | "photoType";
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid ${colorSet.gray9};

    .flex-shrink-0 {
      flex-shrink: 0;
    }

    .ellipsis-middle-header {
      max-width: ${({ tabType }) =>
        tabType === "container" ? "609" : "821"}px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const StyledImage = styled.div`
  width: 209px;
  height: 209px;
  border-radius: 8px;
  border: 1px solid ${colorSet.gray9};
  overflow: hidden;
  cursor: pointer;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.25s;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const ImageSection = styled.section`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const InformationTitleSection = styled.div`
  height: 61px;
  padding: 16px 16px 10px 16px;
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid ${colorSet.gray9};
`;

export const Divider = styled.div<{ gap?: number }>`
  width: 100%;
  border-bottom: 1px solid ${colorSet.gray9};
  ${({ gap }) =>
    gap &&
    css`
      margin: ${gap}px 0;
    `};
`;

export const InformationItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const FlexCenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const NoDataContainer = styled.div`
  height: 210px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const TitleWithSubtitle = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
`;

export const SubtitleText = styled(Typo)`
  margin-left: 4px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ImageDownloadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const InfoIcon = styled(InfoSvg)<{ color: ColorType }>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  path {
    fill: ${({ color }) => colorSet[color]};
  }
`;

export const TooltipContent = styled.div`
  background: ${colorSet.gray1};
  opacity: 0.8;
  max-width: 494px;
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  ${typo.b10m};
  color: ${colorSet.white};
`;

export const TooltipContainer = styled.span`
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 3px;
`;

export const DownloadIcon = styled(DownloadSvg)<{
  color?: ColorType;
  disabled?: boolean;
}>`
  width: 16px;
  height: 16px;

  path {
    ${({ color }) =>
      color &&
      css`
        fill: ${colorSet[color]};
      `}

    ${({ disabled }) =>
      disabled &&
      css`
        fill: ${colorSet.gray8};
      `}
  }
`;

export const InformationSection = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 596px;
  overflow: auto;
`;

export const PhotoTypeItem = styled(FlexAlignCenter)`
  cursor: pointer;

  .ellipsis-label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    background: ${colorSet.gray10};
  }

  &[data-selected="true"] {
    background: ${colorSet.systemBlue6};
  }
`;

export const PhotoTypeList = styled.div`
  display: flex;
  flex-direction: column;
  height: 596px;
  overflow: auto;
  position: relative;
`;

export const ContentLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const selectableItemStyles = css`
  cursor: pointer;

  .ellipsis-label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    background: ${colorSet.gray10};
  }

  &[data-selected="true"] {
    background: ${colorSet.systemBlue6};
  }
`;

export const SelectableListItem = styled(FlexAlignCenter)`
  ${selectableItemStyles}
`;

export const ScrollableList = styled.div`
  display: flex;
  flex-direction: column;
  height: 596px;
  overflow: auto;
  position: relative;
`;
